import { React, useEffect, useState } from 'react';
import styled from 'styled-components';
import Lottie from 'lottie-react-web';

import FetchModule from '../../Share/Network/FetchModule';

import CardIcon from '../../../image/CardIcon.png';
import LoadingAnimation from '../../../Animation/LoadingAnimation.json';

export default function BillingInfoModal(props) {
  const { data, onClickExit } = props;

  const [isInProgress, setIsInPregress] = useState(false);

  const [cardName, setCardName] = useState('');
  const [cardNum, setCardNum] = useState('');
  const [suspensionCode, setSuspensionCode] = useState('');
  const [suspensionReason, setSuspensionReason] = useState('');


  useEffect(() => {
    document.body.style = `overflow: hidden`;
    return () => document.body.style = `overflow: auto`;
  }, [])

  useEffect(() => {
    setCardName(data.cardName === undefined ? '' : data.cardName);
    setCardNum(data.cardNum === undefined ? '' : data.cardNum);
    setSuspensionCode(data.suspensionCode === undefined ? '' : data.suspensionCode);
    setSuspensionReason(data.suspensionReason === undefined ? '' : data.suspensionReason);
  }, [data])

  // 정기결제 클릭시 페이플 버전 // 
  function onClickRegularPaymentOnPayple() {
    const obj = {};

    obj.PCD_PAY_TYPE = 'card'
    obj.PCD_PAY_WORK = 'AUTH'
    // obj.PCD_PAY_WORK = 'PAY'
    obj.PCD_CARD_VER = '01';
    obj.PCD_PAYER_AUTHTYPE = 'sms';
    // obj.PCD_RST_URL = process.env.REACT_APP_TEST_HOSTNAME + '/subscribe/success';
    // obj.PCD_RST_URL = 'https://link-soft.io/';

    // obj.PCD_PAY_GOODS = 'Link-Zone 정기 구독권 (1개월)';
    // obj.PCD_PAY_TOTAL = 100;
    // obj.PCD_PAY_OID = responseData.data[0].nextMerchantUid;


    obj.callbackFunction = getResult;
    obj.clientKey = '0F44C92BFB07F1BE60C5235A7254316D';
    // obj.clientKey = 'test_DF55F29DA654A8CBC0F0A9DD4B556486';

    window.PaypleCpayAuthCheck(obj);
  }


  // 결제 이후 콜백 //
  function getResult(res) {
    if (res.PCD_PAY_RST === 'success' && (res.PCD_PAY_CODE === '0000' || res.PCD_PAY_CODE === 'CDAU1000')) {
      let requestData = {
        billingKey: res.PCD_PAYER_ID,
        cardName: res.PCD_PAY_CARDNAME,
        cardNum: res.PCD_PAY_CARDNUM
      }

      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('billing/registry', 'POST', requestData);

          if (responseData.status === 200) {
            alert('카드번호 등록이 완료되었습니다!');
            onClickExit();
          }
          else {
            onClickExit();
          }
        }
      )();
    }
    else {
      if (res.PCD_PAY_CODE === undefined) {
        console.log(res.PCD_PAY_MSG);
        alert(res.PCD_PAY_MSG);
      }
      else {
        console.log('[' + res.PCD_PAY_CODE + ']' + ' ' + res.PCD_PAY_MSG);
        alert('[' + res.PCD_PAY_CODE + ']' + ' ' + res.PCD_PAY_MSG);
      }
    }
  }

  // 재결제하기 클릭시 //
  function onClickRetryBilling() {
    if (isInProgress) {
      alert('결제가 진행중입니다');
      return;
    }

    setIsInPregress(true);

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('billing/retry/zone', 'POST');
        
        if (responseData.status === 200) {
          alert('결제가 완료되었습니다');
          setIsInPregress(false);
          onClickExit();
        }
        else {
          alert(responseData.error);
          setIsInPregress(false);
        }
      }
    )();
  }


  return (
    <TopLevelWrapper>
      {
        isInProgress ?
          <LottieWrapper>
            <LottieWrapper>
              <Lottie options={{ animationData: LoadingAnimation }} />
            </LottieWrapper>
          </LottieWrapper>
          :
          <ModalView>
            <TitleWrapper>
              <TitleTextWrapper>
                <Text fontFamily='NotoSansKR-Bold' fontSize={16} color='#232323' cursor='default'>서비스 결제 관리</Text>
                <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#777777' cursor='default'>서비스 이용을 위한 카드 정보를 확인해주세요</Text>
              </TitleTextWrapper>
              <ExitButton onClick={onClickExit}>
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#3E4148' cursor='pointer'>취소</Text>
              </ExitButton>
            </TitleWrapper>
            <InfoBoxWrapper>
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#333333' cursor='default'>현재 등록된 카드</Text>
              <InfoBox>
                <Image src={CardIcon} />
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#333333' cursor='default'>{cardName} / {cardNum}</Text>
              </InfoBox>
            </InfoBoxWrapper>
            <InfoBoxWrapper>
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#333333' cursor='default'>결제 가능 여부</Text>
              <InfoBox>
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#333333' cursor='default'>{suspensionCode === '' ? '가능' : suspensionReason}</Text>
              </InfoBox>
            </InfoBoxWrapper>
            <ButtonWrapper>
              <Button onClick={onClickRetryBilling}>
                <Text fontFamily='NotoSansKR-Bold' fontSize={16} color='#FFFFFF' cursor='pointer'>재결제 요청</Text>
              </Button>
              <Button onClick={onClickRegularPaymentOnPayple}>
                <Text fontFamily='NotoSansKR-Bold' fontSize={16} color='#FFFFFF' cursor='pointer'>다른 카드 등록</Text>
              </Button>
            </ButtonWrapper>
          </ModalView>
      }
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  z-index: 1000;
  
  width: 100vw;
  height: 100vh;

  overflow-y: scroll;

  background-color: rgba(0, 0, 0, 0.2);
`;

const LottieWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 80px;
  height: 80px;
`;

const ModalView = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  padding: 20px 0px;

  width: 407px;

  border-radius: 10px;
  background-color: #F9F9F9;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 90.33%;
`;

const TitleTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 4px;
`;

const InfoBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 16px;

  width: 90.33%;
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  padding: 0px 10px;
  margin-top: 8px;

  width: calc(100% - 20px);
  height: 33px;

  gap: 10px;

  background-color: #FFFFFF;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  margin-top: 16px;

  width: 90.33%;
`;

const Button = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 48.5%;
  height: 43px;

  border-radius: 10px;
  background-color: #CFCFCF;

  :hover {
    cursor: pointer;
    background-color: #6DD49E;
  }
  
  transition: all 0.3s ease-in-out;
`;

const Image = styled.img`
  width: 18px;
  height: 18px;
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 62px;
  height: 40px;

  border-radius: 10px;
  background-color: #F5F6F8;

  :hover {
    cursor: pointer;
  }
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;
  
  margin: 0 0 0 0;
  
  color: ${props => props.color};
  
  transition: all 0.3s ease-in-out;

  :hover {
    cursor: ${props => props.hover};
  }
`;
